import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../components/ui/accordion";
import { Section } from "./About";

const QA = [
  ["What is Raphanex Store?", "Raphanex is an online store where you can buy digital products such as e-books, templates, software tools and courses, paid for in Ghana Cedis."],
  ["How do I pay?", "Payments are processed by theteller (PaySwitch Ghana). You can pay with MTN MoMo, Telecel Cash, AT Money, Visa or Mastercard on theteller's secure checkout page."],
  ["When do I get my product?", "Immediately after your payment is verified. Open My Purchases in your dashboard to access it."],
  ["My payment went through but I can't see my product.", "Open Payments in your dashboard and click Check status on the transaction. If it still shows pending after a few minutes, contact support with your payment reference."],
  ["Is my payment information safe?", "Yes. Your card details and Mobile Money PIN are entered only on theteller's checkout. Raphanex never sees or stores them."],
  ["Can I get a refund?", "Because digital products are delivered instantly, refunds are limited. See our Refund Policy for eligible cases."],
  ["I forgot my password.", "Use 'Forgot password' on the login page. Our support team will send you a secure reset link."],
];

export default function FAQ() {
  return (
    <Section eyebrow="FAQ" title="Frequently asked questions.">
      <Accordion type="single" collapsible className="mt-12 max-w-3xl" data-testid="faq-accordion">
        {QA.map(([q, a], i) => (
          <AccordionItem key={q} value={`q${i}`} className="border-white/[0.08]">
            <AccordionTrigger className="py-5 text-left text-base font-semibold text-white hover:no-underline" data-testid={`faq-q-${i}`}>{q}</AccordionTrigger>
            <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-400">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Section>
  );
}
